import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import Iconify from '../../../components/iconify';
import { MenuItem, Stack, TextField } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { loadingStartAction, loadingStopAction } from 'src/redux/actions/loadingActions';
import { useDispatch } from 'react-redux';
import api from 'src/api';

export default function UserWalletUpdate({ type, userId, getAllUsersList, userData, setUserData }) {
  const [open, setOpen] = React.useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  const [walletType, setWalletType] = React.useState('');
  const [amount, setAmount] = React.useState('');
  const dispatch = useDispatch();
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const updateWallet = async () => {
    let reqBody = {
      points: amount,
      transaction_type: type,
      transaction_note: type + 'ed' + ' by admin',
      user_id: userId,
      status: 'accepted',
      isAdmin: true
    };

    let endpoint = 'wallet/create';

    const updateData = userData?.users.map((item) =>
      item._id === userId
        ? {
            ...item,
            wallet_balance:
              type === 'credit'
                ? parseInt(item.wallet_balance) + parseInt(amount)
                : parseInt(item.wallet_balance) - parseInt(amount),
          }
        : item
    );

    setUserData((prevUserData) => ({
      ...prevUserData,
      users: updateData,
    }));

    handleClose();
    // dispatch(loadingStartAction());
    await api.post(endpoint, reqBody);
    // dispatch(loadingStopAction());
    // getAllUsersList()
  };

  return (
    <div>
      {type === 'credit' ? (
        <LoadingButton
          onClick={handleClickOpen}
          style={{ marginRight: 10 }}
          size="small"
          type="submit"
          variant="contained"
          color="success"
        >
          + Add Points
        </LoadingButton>
      ) : (
        <LoadingButton onClick={handleClickOpen} size="small" type="submit" variant="contained" color="error">
          - Withdrawal Points
        </LoadingButton>
      )}
      <Dialog fullScreen={fullScreen} open={open} onClose={handleClose} aria-labelledby="responsive-dialog-title">
        <DialogContent>
          <Stack padding={1} spacing={3}>
            <TextField name="amount" label="Enter Amount" value={amount} onChange={(e) => setAmount(e.target.value)} />

            <LoadingButton
              color={type === 'credit' ? 'success' : 'error'}
              size="large"
              type="submit"
              variant="contained"
              onClick={updateWallet}
            >
              {type === 'credit' ? 'Add Points' : 'Withdrawal Points'}
            </LoadingButton>
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleClose}>
            Skip Now
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
